"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = exports.Wrapper = exports.GlobalStyle = void 0;
const flora_1 = require("@grupoboticario/flora");
// Helpers
const utils_1 = require("../../utils");
exports.GlobalStyle = (0, flora_1.globalCss)({
    body: {
        overflow: 'hidden',
    },
});
exports.Wrapper = (0, flora_1.styled)('div', {
    variants: {
        fullScreen: {
            true: Object.assign({ position: 'fixed', background: 'rgba(255,255,255,.5)', width: '100vw', height: '100vh', top: 0, left: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999999 }, (utils_1.isMobile.any()
                ? {
                    left: '50%',
                    transform: 'translate(-50%, 0)',
                    width: '560px',
                }
                : {})),
        },
    },
});
const spin = (0, flora_1.keyframes)({
    '0%': {
        transform: 'rotate(0deg)',
    },
    '100%': {
        transform: 'rotate(360deg)',
    },
});
exports.Loading = (0, flora_1.styled)('div', {
    borderRadius: '100%',
    border: '6px solid $disabledBackground',
    animation: `${spin} 1s linear infinite`,
    webkitAnimation: `${spin} 1.5s linear infinite`,
});
